<template>
<div class="mIndividualization">
    <Header></Header>
    <div class="content_warp">
        <div class="top_box">
            <p class="p_title">个性化需求定制服务</p>
            <p class="p_desc">从客户痛点出发，专注解决各种股权问题</p>
            <button @click="MessageBtn" class="btn">留言咨询</button>
        </div>
        <div class="warp1">
            <p class="title_text">股权协议合同拟定</p>
            <img class="template_img" :src="require('@/common/images/gujingimgs/template.png')" alt="">
            <p class="tips_text">协议合同只做展示用途，以上为部分模版展示。</p>
        </div>
        <div class="warp2">
            <p class="title_text">远程定制股权方案</p>
            <div class="scheme_warp">
                <div class="scheme_item" v-for="(item, index) in schemeData" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <p class="p_title">{{item.nameText}}</p>
                    <p class="p_desc" v-html="item.descText"></p>
                </div>
            </div>
        </div>
        <div class="warp3">
            <img class="inset_img" :src="require('@/common/images/gujing/individualization/item.png')" alt="">
            <p class="title_text">更多股权相关服务</p>
            <div class="serve_list_warp">
                <div class="serve_list_item" v-for="(item, index) in serveList" :key="index">
                    <p class="p_title">{{item.nameText}}</p>
                    <p class="p_desc">{{item.descText}}</p>
                </div>
            </div>
        </div>
        <div class="warp4">
            <p>联系我们，了解更多需求定制服务</p>
            <div @click="MessageBtn" class="btn_div">留言咨询</div>
        </div>
    </div>
    <Footer></Footer>
    <transition name="slide-fade">
        <div>
            <img class="contact_img" v-show="!showContactTel && show" @click="showContactTel = !showContactTel" :src="require('@/common/images/gujingimgs/icon_contact.png')" alt="">
            <img class="contact_tel_img" v-show="showContactTel && show" @click="showContactTel = !showContactTel" :src="require('@/common/images/gujingimgs/icon_tel.png')" alt="">
            <img class="gotop_img" @click="goTop" v-show="show" :src="require('@/common/images/gujingimgs/go_top.png')" alt="">
        </div>
    </transition>
</div>
</template>

<script>
import Header from 'views/gjMobile/components/Header'
import Footer from 'views/gjMobile/components/Footer'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MIndividualization',
    data() {
        return {
            showContactTel: false,
            show: false,
            schemeData: [
                {
                    nameText: '明确需求',
                    imgUrl: require('@/common/images/gujing/individualization/icon (2).png'),
                    descText: '按照一定的模式与格式收集客户信息，咨询师指导客户清晰和明确自身需求'
                },
                {
                    nameText: '方案设计',
                    imgUrl: require('@/common/images/gujing/individualization/icon (3).png'),
                    descText: '根据行业特性、发展阶段、企业特点、股东想法等因素，凭借咨询师丰富经验形成方案初稿'
                },
                {
                    nameText: '方案定稿',
                    imgUrl: require('@/common/images/gujing/individualization/icon (4).png'),
                    descText: '专业咨询师与客户远程沟通讨论，针对核心关键问题分析并决策，形成最终落地方案'
                },
                {
                    nameText: '配套文件',
                    imgUrl: require('@/common/images/gujing/individualization/icon (5).png'),
                    descText: '咨询师根据最终方案，协助客户修改股权转让、合作、投资等相关配套文件'
                }
            ],
            serveList: [
                {
                    nameText: '股权激励全案服务',
                    descText: '项目深度调研、股权激励方案设计、培训宣讲落地实施、长期动态优化调整'
                },
                {
                    nameText: '常年资本顾问服务',
                    descText: '远程24h会议沟通、上市规划建议指导、融资并购建议指导、企业股权问题建议'
                },
                {
                    nameText: '定制商业计划书',
                    descText: '投资视角下商业模式优化、企业价值评估、资本运营规划、融资路演指导'
                },
                {
                    nameText: '股权融资顾问服务',
                    descText: '挖掘企业投资亮点、定制优化融资方案、高效匹配投资机构、投资条款投资协议修改'
                },
            ]
        }
    },
    created() {
        // 判断是移动端还是PC端 并跳转到相应页面
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'Individualization'
            })
        }
    },
    activated() {
        $('html,body').animate({scrollTop:'0px'},0)
    },
    mounted() {
        $('html,body').animate({scrollTop:'0px'},0)
        let _this = this
        $(window).scroll(function () {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let clientHeight = document.body.clientHeight / 2
            if(scrollTop >= clientHeight){
                _this.show = true
            }
            else{
                _this.show = false
            }
        })
    },
    methods: {
        // 留言咨询
        MessageBtn() {
            this.$router.push({name: 'Msg'})
        },
        // 回到顶部
        goTop() {
            $('html,body').animate({scrollTop:'0px'},300)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {Header,Footer}
}
</script>

<style lang="scss" type="text/scss">
.mIndividualization {
    position: relative;
    background-color: #F5F7FA;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family:PingFangSC-Medium,PingFang SC;
    .content_warp {
        flex: 1;
        // padding-bottom: 0.2rem;
        .top_box {
            height: 5.6rem;
            background: url('../../../common/images/gujingimgs/intro-bg.png') no-repeat center;
            background-size: 100% 100%;
            color: #FFF;
            padding: 0 0.32rem;
            padding-top: 1.6rem;
            box-sizing: border-box;
            .p_title {
                font-size: 0.48rem;
                line-height: 0.68rem;
                font-weight: bold;
            }
            .p_desc {
                margin: 0.4rem 0;
                font-size: 0.3rem;
                line-height: 0.46rem;
            }
            .btn {
                width: 2.2rem;
                height: 0.6rem;
                font-size: 0.28rem;
                background:linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                border: none;
                border-radius: 0.3rem;
            }
        }
        .title_text {
            position: relative;
            text-align: center;
            font-size: 0.36rem;
            line-height: 0.5rem;
            margin-bottom: 0.6rem;
            color: #333;
            font-weight: bold;
            &::before {
                content: '';
                position: absolute;
                margin: auto;
                bottom: -0.12rem;
                left: 0;
                right: 0;
                width:0.36rem;
                height:0.04rem;
                background: #409EFF;
            }
        }
        .warp1, .warp2 {
            background-color: #fff;
            padding: 0 0.32rem;
            padding-top: 0.56rem;
            padding-bottom: 0.48rem;
            .template_img {
                width: 100%;
                margin-bottom: 0.4rem;
            }
            .tips_text {
                color: #999;
                font-size: 0.24rem;
                line-height: 0.34rem;
                text-align: center;
            }
        }
        .warp2 {
            background-color: #F5F7FA;
            padding-top: 0.48rem;
            padding-bottom: 0;
            .scheme_warp {
                display: flex;
                flex-wrap: wrap;
                .scheme_item {
                    width: 3.27rem;
                    height: 4.48rem;
                    background-color: #fff;
                    margin-bottom: 0.48rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    // box-shadow:0 0.01rem 0.08rem 0 rgba(0,0,0,0.15);
                    border-radius:0.06rem;
                    &>img {
                        margin-top: 0.4rem;
                        width: 1.2rem;
                        height: 1.2rem;
                    }
                    .p_title {
                        margin: 0.28rem 0;
                        line-height: 0.4rem;
                        color: #333;
                        font-size: 0.28rem;
                    }
                    .p_desc {
                        color: #666;
                        font-size: 0.24rem;
                        line-height: 0.36rem;
                        padding: 0 0.24rem;
                    }
                }
                .scheme_item:nth-of-type(2n){
                    margin-left: 0.32rem;
                }
            }
        }
        .warp3 {
            padding-top: 0.48rem;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            .inset_img {
                width: 4.3rem;
                height: 2.85rem;
                margin-bottom: 0.48rem;
            }
            .serve_list_warp {
                width: 100vw;
                .serve_list_item {
                    margin-left: 0.32rem;
                    margin-bottom: 0.48rem;
                    width: 6.24rem;
                    .p_title {
                        color: #409EFF;
                        font-size: 0.32rem;
                        line-height: 0.52rem;
                    }
                    .p_desc {
                        color: #666;
                        font-size: 0.28rem;
                        line-height: 0.52rem;
                    }
                }
                // .serve_list_item:nth-last-of-type(1){
                //     margin-bottom: 0;
                // }
            }
        }
        .warp4 {
            height: 4.54rem;
            background: url('../../../common/images/gujingimgs/bg1.png') no-repeat center;
            background-size: 100% 100%;
            color: #FFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &>p {
                line-height: 0.54rem;
                font-size: 0.38rem;
                margin-bottom: 0.62rem;
            }
            .btn_div {
                border: 0.01rem solid #fff;
                box-sizing: border-box;
                font-size: 0.28rem;
                width: 2.2rem;
                height: 0.6rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.6rem;
            }
        }
    }
    .gotop_img, .contact_img, .contact_tel_img {
        width: 1.16rem;
        height: 1.16rem;
        position: fixed;
        right: 0.2rem;
        bottom: 2.15rem;
        opacity: 1;
    }
    .contact_tel_img {
        width: 3.02rem;
    }
    .gotop_img {
        bottom: 1rem;
    }
}
.slide-fade-enter-active, .slide-fade-leave-active {
    transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
}
</style>